import { h } from 'preact';
import { useState } from 'preact/hooks';
import StartPage from './StartPage';
import QuizPage from './QuizPage';
import FinishPage from './FinishPage';
import ResultPage from './ResultPage';
import { QUESTIONS } from './Questions';
import './App.css'

const App = () => {
  const QUIZ_COUNT = 15; // 出題数を定数として定義
  const [currentPage, setCurrentPage] = useState('start');
    const [shuffledQuestions, setShuffledQuestions] = useState([]);
  const [userAnswers, setUserAnswers] = useState([]);

  const handleStart = () => {
    const shuffled = [...QUESTIONS]
      .sort(() => Math.random() - 0.5)
      .slice(0, QUIZ_COUNT);

    setShuffledQuestions(shuffled);
    setUserAnswers(Array(QUIZ_COUNT).fill(''));
    setCurrentPage('quiz');
  };

  const handleQuizFinish = (answers) => {
    setUserAnswers(answers);
    setCurrentPage('finish');
  };

  const handleShowResult = () => {
    setCurrentPage('result');
  };

  const handleRetry = () => {
    setCurrentPage('start');
    setUserAnswers([]);
    setShuffledQuestions([]);
  };

  switch (currentPage) {
    case 'start':
      return <StartPage onStart={handleStart} />;
    case 'quiz':
      return (
        <QuizPage
          questions={shuffledQuestions}
          userAnswers={userAnswers}
          setUserAnswers={setUserAnswers}
          onFinish={handleQuizFinish}
        />
      );
    case 'finish':
      return <FinishPage onShowResult={handleShowResult} />;

    case 'result':
      return (
        <ResultPage
          questions={shuffledQuestions}
          answers={userAnswers}
          onRetry={handleRetry}
        />
      );
    default:
      return <div>エラーが発生しました</div>;
  }
};

export default App;



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/